import { videoCommentsApi } from "../../../Api/VideoComments";
import { useContentComments } from "../useContentComments";

export {
    describeVideoCommentError,
    videoCommentErrorCode,
    VideoCommentClientError,
} from "../useContentComments";

export function useVideoComments(videoId: number | undefined) {
    return useContentComments(videoId, videoCommentsApi, "video");
}

export type VideoCommentsController = ReturnType<typeof useVideoComments>;
